import { config } from './config';

const CURSORS_LIST = [
  { id: 1, label: 'Dark', className: 'billy-dom__cursor_dark', src: `${config.ROOT}/static/images/cursors/dark.png` },
  { id: 2, label: 'Bright', className: 'billy-dom__cursor_light', src: `${config.ROOT}/static/images/cursors/light.png` }
]

export { 
  CURSORS_LIST
};


// WEBPACK FOOTER //
// ./src/constants/cursorsList.js